import { render, staticRenderFns } from "./TermsNavbar.vue?vue&type=template&id=060edaa2&scoped=true&"
import script from "./TermsNavbar.vue?vue&type=script&lang=js&"
export * from "./TermsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TermsNavbar.vue?vue&type=style&index=0&id=060edaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060edaa2",
  null
  
)

export default component.exports